export const TRIGGERABLE_TYPE_CONVERT_QUOTE = "convert-quote-to-invoice-automation"
export type TriggerableType = 
    "order-status-automation"
    | "convert-quote-to-invoice-automation" 

export const CONVERT_QUOTE_COMMAND: CommandType = "convert-quote-to-invoice-command"
export type CommandType = 
    "change-order-status-command"
    | "convert-quote-to-invoice-command"

export const FULLY_PAID_QUOTE_TRIGGER: TriggerType = "fully-paid-quote-trigger"
export type TriggerType =
    "fully-invoiced-trigger"
    | "fully-received-trigger"
    | "fully-paid-quote-trigger"
    



// WEBPACK FOOTER //
// ./src/state/triggerable/triggerableTypes.ts